import { render, staticRenderFns } from "./tabInternalServiceRecordOfBeneficiary.vue?vue&type=template&id=012390d1&"
import script from "./tabInternalServiceRecordOfBeneficiary.vue?vue&type=script&lang=ts&"
export * from "./tabInternalServiceRecordOfBeneficiary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports